import { Link } from 'react-router';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project import
import Logo from 'assets/svgs/LogoMain';
import LogoIcon from 'assets/svgs/LogoIcon';
import useStore from 'zustand-store';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  isIcon?: boolean;
  isWhite?: boolean;
  sx?: SxProps;
  iconProps?: React.SVGProps<SVGSVGElement>
}

const LogoSection = ({ iconProps, isIcon, isWhite = false, sx }: Props) => {
  const isLogged = useStore(state=>state.isLogged)

  return <ButtonBase disableRipple component={Link} to={isLogged ? '/home' : '/login'} sx={sx}>
    {isIcon ? <LogoIcon {...iconProps} /> : <Logo iconProps={iconProps} isWhite={isWhite} />}
  </ButtonBase>
};

export default LogoSection;
